// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"RunsTable_checkbox__3rv3d","checkedCheckbox":"RunsTable_checkedCheckbox__1EllI","sortingBox":"RunsTable_sortingBox__1l_Cd"};